<template>
  <div class="creators-wrapper">
    <div class="creators-main">
      <div class="creators-main__content">
        <div class="creators-main__header">
          <creators-club-logo class="creators-main__logo"></creators-club-logo>
          <div class="creators-main__title">
            Ylands<br />
            <span class="strong">Creators Club</span>
          </div>
        </div>

        <div class="creators-main__description">
          <p>
            <strong
              >Join an elite group of Creators and enjoy the benefits!</strong
            >
            More Coyns for your creativity, the ability to apply for a Creators
            Commission, exclusive in-game items and more!
          </p>
        </div>
        <div class="creators-main__small-title">
          BECOME A MEMBER TO ENJOY
        </div>
        <div class="creators-main__list">
          <ul>
            <li>
              <strong>Riches:</strong> more Coyns for your creativity, the
              ability to apply for a Creators Commission to get real-world rich
              thanks to your ingenuity, exclusive in-game items and more!
            </li>
            <li>
              <strong>Fame:</strong>
              Creators Club members will always have their creative content
              showcased on our dev streams. That’s a lot of eyeballs admiring
              your work! You’ll also have the opportunity to play with Ylands
              devs and become a valued member of the Ylands team.
            </li>
            <li>
              <strong>Style:</strong>
              You’ll never go out of style when you’re part of the Creators
              Club. That’s because you’ll be eligible for exclusive in-game
              merch and special sales opportunities.
            </li>
          </ul>
        </div>

        <default-button
          class="creators-main__very-dark-blue-button"
          :color="'veryDarkBlue'"
          :text="'JOIN THE CLUB'"
          :link="JOIN_CREATORS_CLUB_PAGE_NAME"
          :component-nav="true"
          :width-static="'230px'"
        />
      </div>
      <div class="creators-main-right-image">
        <ImageOptimized
          :file-name="'/home/become_member/vip-crowd_cclub'"
          :alt="'BECOME A MEMBER TO ENJOY'"
          :sizes="['600', '1000', '1920']"
          :load="'lazy'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { JOIN_CREATORS_CLUB_PAGE_NAME } from '@/router/pageNameConstants.js';

import Button from '@/components/common/Button';
import CreatorsClubLogo from 'Svgs/ylands_creators_club.svg?inline';
import ImageOptimized from '@/components/common/ImageScaler';

export default {
  name: 'YlandsCreatorsClub',
  components: {
    CreatorsClubLogo,
    'default-button': Button,
    ImageOptimized,
  },
  data: function() {
    return {
      JOIN_CREATORS_CLUB_PAGE_NAME,
      veryDarkBlueButton: {
        backgroundColor: '#0a294a',
        border: '2px solid #0a294a',
        width: '249px',
        borderRadius: '6px',
      },
    };
  },
};
</script>

<style scoped lang="scss">
.creators-wrapper {
  overflow: hidden;
  background: url('~Images/home/creators_club_background-eb.png') no-repeat
    center center;
  background-size: cover;
  position: relative;
  display: flex;
  justify-content: center;
}
.creators-main {
  position: relative;
  display: flex;
  max-width: 1280px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 0 25px;
  padding: 120px 0;

  @media (max-width: $sm-up) {
    flex-direction: column;
    padding: 45px 0;
  }

  .creators-main__content {
    flex: 1 2 auto;
    .creators-main__header {
      display: flex;
      align-items: center;
      margin-bottom: 45px;

      @media (max-width: $sm-up) {
        justify-content: center;
      }

      @media (max-width: $xs-up) {
        flex-direction: column;
      }

      .creators-main__logo {
        width: 94px;
        height: 92px;
        margin-right: 14px;
        @media (max-width: $xs-up) {
          margin-right: 0;
          margin-bottom: 30px;
        }
      }

      .creators-main__title {
        color: $blue-main;
        font-family: $politica-font;
        font-size: 55px;
        font-weight: 700;
        letter-spacing: 2.5px;
        @media (max-width: $xs-up) {
          text-align: center;
          font-size: 35px;
          letter-spacing: 0.7px;
          line-height: 40px;
        }
      }
    }

    .creators-main__description {
      margin: 0;
      text-align: left;
      font-family: $palanquin-font;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.56px;
      line-height: 30px;
      color: $blue-main;
    }

    .creators-main__small-title {
      color: $blue-main;
      font-family: $istok-font;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.16px;
      line-height: 30px;
      text-transform: uppercase;
    }

    .creators-main__list {
      margin: 0;
      color: $blue-main;
      font-family: $istok-font;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.16px;
      line-height: 30px;
      margin-bottom: 30px;
      ul {
        margin: 0;
        padding: 0;
        list-style-type: none;

        li {
          &:first-child {
            padding-top: 10px;
          }
          &:not(:first-child) {
            padding-top: 20px;
          }
        }
      }
    }
    .creators-main__very-dark-blue-button {
      @media (max-width: $sm-up) {
        margin: 0 auto;
      }
    }
  }

  .creators-main-right-image {
    position: relative;
    max-width: 100%;
    height: auto;
  }
}
</style>
